var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { lg: _vm.lg, md: _vm.md, xs: "12" } },
    [
      _c(
        "w-card",
        [
          !_vm.project.ContactID
            ? _c(
                "w-card-content",
                [
                  _c("app-project-select-contact", {
                    attrs: { project: _vm.project },
                  }),
                ],
                1
              )
            : _vm.project.Contact
            ? _c(
                "w-card-content",
                [
                  _c(
                    "div",
                    { style: { display: "flex", flexDirection: "row" } },
                    [
                      _c("span", { staticClass: "contact" }, [
                        _vm._v(_vm._s(_vm.project.Contact.getDisplayName())),
                      ]),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          staticClass: "sale-edit link ml",
                          on: {
                            click: function ($event) {
                              return _vm.clearContact()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("settings-edit")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _vm.project.Contact.MainAddress
                    ? [
                        _c("div", { staticClass: "address" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.project.Contact.MainAddress.AddressLine1
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.project.Contact.MainAddress.PostalAndCity
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "props phone mt" }, [
                          _c(
                            "a",
                            {
                              staticClass: "w-link",
                              attrs: {
                                href: _vm.project.Contact.getCleanPhone(),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.triggerPhone(
                                    _vm.project.Contact.MainAddress.Phone
                                  )
                                },
                              },
                            },
                            [
                              _vm.project.Contact.MainAddress.Phone
                                ? _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "phone-square-alt" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                _vm._s(_vm.project.Contact.MainAddress.Phone)
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "ml w-link",
                              attrs: {
                                href: _vm.project.Contact.getCleanMobile(),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.triggerPhone(
                                    _vm.project.Contact.MainAddress.Mobile
                                  )
                                },
                              },
                            },
                            [
                              _vm.project.Contact.MainAddress.Mobile
                                ? _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "phone-square-alt" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                _vm._s(_vm.project.Contact.MainAddress.Mobile)
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card",
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("properties")))]),
          _c(
            "w-card-content",
            [
              _c("app-project-edit-properties", {
                attrs: { project: _vm.project },
                on: {
                  save: function ($event) {
                    return _vm.save()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }